// ファイル選択
import React from 'react';
import Form from 'react-bootstrap/Form';
import { FileUpload } from '../types/FileUpload';
import { addFallBackSource } from '../Common';

interface Props {
  file_upload: FileUpload;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileSelect: React.FC<Props> = ({ file_upload, handleChange }) => {
  return (
    <Form.Control
      className="form-select file-select"
      as="select"
      onChange={handleChange}
      value={file_upload.default_value}
      disabled={file_upload.is_loading || file_upload.is_uploaded}
    >
      {addFallBackSource(file_upload?.source)?.map((source) => {
        return (
          <option key={source.key} value={source.key}>
            {source.value}
          </option>
        );
      })}
    </Form.Control>
  );
};

export default FileSelect;
